import ServiceBase from "@affinity/Store/ServiceBase";
import { HarrierPricingModel, PriceOptionViewModel } from "@affinity/Store/StoreTypes";
import logger from "@insite/client-framework/Logger";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

class ServiceRealTimePricing extends ServiceBase {
    getAffinityKeroseneVatDeclaration(value: ShipToModel) {
        try {
            return this.GetCustomPropertyValue(value, this.CustomPropertyNames.Customer.affinityKeroseneVatDeclaration);
        } catch (error) {
            logger.warn(`Error accessing custom property Orders shipTo: ${error}`);
            return undefined;
        }
    }

    async getHarrierPricing(productId: string, quantity: number, postCode: string) {
        const harrierPricingParameters = {
            postCode,
            productId,
            quantity,
        } as ApiParameter;

        const result = await get<HarrierPricingModel>(`${this.harrierPricingUrl}`, harrierPricingParameters);
        return result;
    }

    mapRealTimePricing(result: HarrierPricingModel): PriceOptionViewModel[] {
        const pricingItems = result.items ?? [];
        const mapResults = pricingItems.map(p => {
            return {
                id: `priceID: ${p.harrierSource.priceId.toString()} ,supplierId: ${p.harrierSource.supplierId.toString()}`,
                quantity: p.harrierSource.quantity,
                deliveryBy: new Date(p.harrierSource.deliveryBy),
                netCost: p.totalWithUpliftAndVAT, // Total should include the Uplift and VAT
                netUnitPrice: p.unitPriceWithUplift, // Total should include Uplift but exclude VAT
            } as PriceOptionViewModel;
        }) ?? [];
        return mapResults;
    }
}

export default ServiceRealTimePricing;